// Centralized registry of z index
// This is needed to establish a consistent hierarchy

// Strive to have the lowest zIndex on each component
export const zIndexVoxel = {
  tableStickyHeadRow: 'z-10',
  inputIcon: 'z-10',
  selectOption: 'z-20',
  drawer: 'z-[1400]',
  dialogBackdrop: 'z-[1450]',
  dialogWindow: 'z-[1475]',
  popover: 'z-[1500]', // Needs to be above dialog in order to be visible (because it's in a portal)
  tooltip: 'z-[1600]',
  selectContainer: 'z-[4000]',
};
